import React from "react";
import Page from "../../page";

export default () => {
  return (
    <Page title="Cancelled">
      <div>
        <h1>Before you go:</h1>
        <p>Please enjoy a 5% discount because we like you so much.</p>
      </div>
    </Page>
  );
};